export default {
  methods: {
    async checkSession() {
      clearTimeout(this.$store.state.sessionTimeout);
      const res = await this.$store.dispatch("checkSession");
      if (!res) return;
      const time = this.$store.state.sessionNotificationTime;
      if (res !== true && res <= time) {
        this.$notify({
          type: "warn",
          title: "Session time ending",
          text: `Session will end in less than ${res} minutes`
        });
      }
      this.$store.state.sessionTimeout = setTimeout(() => {
        this.checkSession();
      }, 60000);
    }
  }
};
